import { renderDate } from '../utility/personTabGridHelper';

export const ADDRESS_GRID_COLUMNS = [
  { field: 'FullAddressText', headerName: 'Full Address', width: 260 },
  { field: 'IsPrimary', headerName: 'Is Primary', width: 110, type: 'boolean' },
  { field: 'AddressID', headerName: 'Address ID', width: 130 },
  { field: 'AddressNumber', headerName: 'Number', width: 120 },
  { field: 'StreetName', headerName: 'Street Name', width: 200 },
  { field: 'StreetType', headerName: 'Street Type', width: 150 },
  { field: 'City', headerName: 'City', width: 160 },
  { field: 'State', headerName: 'State', width: 110 },
  { field: 'PostalCode', headerName: 'Postal Code', width: 140 },
  { field: 'PostalCodeExtension', headerName: 'Extension', width: 150 },
  { field: 'Country', headerName: 'Country', width: 140 },
  { field: 'AddressCategory', headerName: 'Address Category', width: 180 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
